import React from 'react';

const doneButton = (props) => {
  const extraClasses = typeof props.classes !== 'undefined' ? props.classes : [];
  const classes = ['button'].concat(extraClasses);
  if (typeof props.visible !== 'undefined' && !props.visible) {
    classes.push('hidden');
  }
  return (
    <button className={classes.join(' ')}
            disabled={!props.active}
            onClick={props.buttonClicked}>
      { props.children }
    </button>
  );
};

export default doneButton;
